import React from 'react';
import lunchLogo from '../../img/logo-lunch-team.svg';

const logo = props => {
  return (
    <div className="menu-logo">
      <a onClick={() => props.goToMenu(1)}>
        <img src={lunchLogo} alt="Lunch Team Logo" />
      </a>
    </div>
  );
};

export default logo;



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js